import { t } from "i18next";
import { tv } from "tailwind-variants";
import emptyDashboard from "@/assets/images/collect/stressed-person-using-computer-at-desk.png";
import { HeaderTextBlock } from "@/components/Typography";
import { Button } from "@/components/Button";

const styles = tv({
  slots: {
    container: "mx-auto my-30 max-w-[420px]",
    center: "flex flex-row justify-center",
    headerTextBlockContainer: "mb-30 mt-45",
    image: "h-[145px]",
  },
});

interface IProps {
  featureText?: string;
  headingText?: string;
  descriptionText?: string;
  ctaAction?: () => void;
}

const EmptyDashboard = ({
  featureText = t("components.emptyState.dashboard.feature"),
  headingText = t("components.emptyState.dashboard.heading"),
  descriptionText = t("components.emptyState.dashboard.description"),
  ctaAction,
}: IProps) => {
  const { container, center, headerTextBlockContainer, image } = styles();

  return (
    <div className={container()} data-testid="empty-dashboard">
      <div className={center()}>
        <img src={emptyDashboard} className={image()} />
      </div>
      <div className={headerTextBlockContainer()}>
        <HeaderTextBlock
          align="center"
          featureText={featureText}
          featureTextColor="primary"
          headingText={headingText}
          headingTextColor="secondary"
          descriptionText={descriptionText}
          descriptionTextColor="secondary"
        />
      </div>
      {!!ctaAction && (
        <div className={center()}>
          <Button variant="primary" onClick={ctaAction}>
            {t("components.emptyState.dashboard.cta")}
          </Button>
        </div>
      )}
    </div>
  );
};

export default EmptyDashboard;
